import { forwardRef } from 'react';
import type { ButtonHTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

const styles = {
  primary:
    'bg-accent-500 text-ink-950 shadow-panel hover:bg-accent-400 focus-visible:outline-accent-300',
  secondary:
    'border border-white/10 bg-white/5 text-slate-100 hover:bg-white/10 focus-visible:outline-white/50',
  ghost: 'text-slate-300 hover:bg-white/8 hover:text-white focus-visible:outline-white/30',
  danger: 'bg-rose-500/90 text-white hover:bg-rose-400 focus-visible:outline-rose-300',
} as const;

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: keyof typeof styles;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, variant = 'primary', type = 'button', ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2 text-sm font-semibold transition duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        styles[variant],
        className,
      )}
      {...props}
    />
  );
});

